const groupAnnouncementsRoute = ({ groupId }) =>
  `/management_panel/groups_management/${groupId}/announcements`

export { groupAnnouncementsRoute }
